import React from 'react';
import server from "../../server";

import Main from "./pages/Main";

import * as $ from 'jquery'

import "./scripts/header/index.js";
import "./scripts/mobile-menu/mobile-menu.js";
import "./scripts/scrollbar/index.js";
import { Header } from './Header';
import Checkout from './pages/Checkout';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import DoctorPage from './pages/Doctor';

function AppointmentRoute({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          server.homeAppointmentData ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/home",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );
  }

export default class Home extends React.Component{
    state = {
        register:false,
        error:null,
        cpf: "",
        areas:[],
        modal:false
    }

    componentDidMount(){
        // UNCOMMENT THIS IF YOU WANT AUTO LOGIN
        //let auto = localStorage.getItem("autoLogin");
        //if(auto == "true") this.autoLogin();
        let that = this;

        this.setState({cpf:localStorage.getItem("CPF")})

        $("#contact-form-link").click(function() {
            $('html, body').animate({
                scrollTop: $("#contact-form").offset().top
            }, 1500);
        });

        /*$("#doctor-banner-link").click(function() {
            $('html, body').animate({
                scrollTop: $(".banner-doctor").offset().top - 70 
            }, 1500);
        });

        $("#patient-link").click(function() {
            $('html, body').animate({
                scrollTop: $("#welcome").offset().top - 70
            }, 1500);
        });*/

       /* document.getElementById('enterPassword').onkeydown = function(e){
            if(e.keyCode == 13){
              that.login();
            }
         };*/
    }

    login = () => {
        const data = {cpf:this.state.cpf.replace(/\./g,'').replace(/\-/g,''),password:this.state.password}

        fetch(server.address+"/login",{
            method:'POST',
            headers:{
                'Accept': 'application/json',
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)

        }).then((response) => response.json().then(data => {
            if(response.ok){
                this.storeData(data.user, data.areas);
            }else{
                this.props.alert("Erro ao logar.",data.toString(),"error");
            }
        }))
    }

    autoLogin = () =>{
        const cpf = localStorage.getItem("CPF");
        const password = localStorage.getItem("password");
        this.setState({cpf:cpf,password:password},this.login);
    }

    storeData = (data, areas) => {
        //Store Clinic Data
        if(data.clinic){
            localStorage.setItem("clinic", JSON.stringify(data.clinic));
            server.clinic = data.clinic;
        }else{
            localStorage.setItem("clinic", null);
            server.clinic = null;
        }

        //Store User Data
        localStorage.setItem("user", JSON.stringify(data))
        server.user = data;
        server.profileImage = "https://s3-sa-east-1.amazonaws.com/blues-fisioterapia-user-upload/images/profile/" + server.user.profilePicture;

        //Store User Id
        localStorage.setItem("userId", data.id)

        //Store CPF
        localStorage.setItem("CPF", this.state.cpf)

        //Set Auto Login
        localStorage.setItem("autoLogin", true);
        localStorage.setItem("password", this.state.password);

        this.setState({modal:true, areas:areas})
    }

    changeState = (e) =>{
        this.setState({[e.target.id]:e.target.value})
    }

    render(){
        return(
            <div style={{margin:0, padding:0}}>
                <Router>
                    <Header logged={this.props.logged} 
                        active={this.state.modal} 
                        areas={this.state.areas} 
                        login={this.login} 
                        cpf={this.state.cpf} 
                        password={this.state.password} 
                        changeState={this.changeState}/>
                    <Route path="/home/medico" component={() => <DoctorPage/>} />
                    <Route path="/home" exact component={() => <Main onChange={this.changeState}/>}/>
                    <AppointmentRoute path="/home/checkout" component={() => <Checkout alert={this.props.alert}/>}/>
                </Router>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/Home.js